import "./styles.scss";

import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";

function ModalAlertContentSpecific({ showModal, setShowModal, handleConfirmContentSpecific }) {
  const { t } = useTranslation();

  const handleClose = () => setShowModal(false);

  const handleConfirm = () => {
    handleConfirmContentSpecific();
    handleClose();
  };

  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      className="modalPrivilege"
      aria-labelledby="alert-dialog-title"
      classes={"modalAlertContentSpecific"}
      aria-describedby="alert-dialog-description"
    >
      <div className="containerAlertContentSpecific">
        <h3 className="title">{t("TITLE_ALERT_ADD_CONTENT_SPECIFIC")}</h3>

        <p className="description">{t("DESCRIPTION_ALERT_ADD_CONTENT_SPECIFIC")}</p>

        <div className="footer">
          <button type="submit" onClick={handleConfirm} className="buttonModalSave">
            {t("YES")}
          </button>
          <button type="button" onClick={handleClose} className="buttonModalBack">
            {t("NO")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalAlertContentSpecific;
